import { getAbTestV2, trackAbTestV2Variant } from 'dibs-ab-tests/exports/clientAbTestV2.ts';

const FULL_SCREEN_APP_DOWNLOAD_DESIGN_TEST_NAME = 'fullScreenAppDownloadDesign_May2026';

function isFullScreenAppDownloadDesignTestVariant(): boolean {
    return getAbTestV2(FULL_SCREEN_APP_DOWNLOAD_DESIGN_TEST_NAME)?.variant === 'variant';
}

function trackFullScreenAppDownloadDesignAbTest(): void {
    trackAbTestV2Variant(FULL_SCREEN_APP_DOWNLOAD_DESIGN_TEST_NAME);
}

export { isFullScreenAppDownloadDesignTestVariant, trackFullScreenAppDownloadDesignAbTest };
